/**
 * Нормализует перенаправление внутри приложения
 * @param redirect - Перенаправление
 * @returns Нормализованный путь
 */
export function normalizeInternalAppRedirect(
  redirect: string | null | undefined,
): string | null {
  const value = redirect?.trim();
  if (
    !value ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\')
  ) {
    return null;
  }

  const path = value.split(/[?#]/, 1)[0];
  let decodedPath: string;
  try {
    decodedPath = decodeURIComponent(path);
  } catch {
    return null;
  }

  if (decodedPath.split('/').some((segment) => segment === '..')) {
    return null;
  }

  if (path === '/app' || path.startsWith('/app/')) {
    return value;
  }

  return `/app${value}`;
}
